import { CSS_VAR } from "./css-variables";

/** Reference CSS theme variables (no hex literals). Requires bootstrapTheme() at startup. */
function v(name: string): string {
	return `var(${name})`;
}

export const themeVar = {
	primary: v(CSS_VAR.color.primary),
	primaryForeground: v(CSS_VAR.color.primaryForeground),
	primaryHover: v(CSS_VAR.color.primaryHover),
	primarySoft: v(CSS_VAR.color.primarySoft),
	primarySoftHover: v(CSS_VAR.color.primarySoftHover),
	primarySoftBorder: v(CSS_VAR.color.primarySoftBorder),
	primarySoftText: v(CSS_VAR.color.primarySoftText),
	primaryMuted: v(CSS_VAR.color.primaryMuted),
	background: v(CSS_VAR.color.background),
	foreground: v(CSS_VAR.color.foreground),
	surface: v(CSS_VAR.color.surface),
	surfaceMuted: v(CSS_VAR.color.surfaceMuted),
	border: v(CSS_VAR.color.border),
	borderStrong: v(CSS_VAR.color.borderStrong),
	danger: v(CSS_VAR.color.danger),
	success: v(CSS_VAR.color.success),
	muted: v(CSS_VAR.color.muted),
	disabledBackground: v(CSS_VAR.color.disabledBackground),
	sidebarPrimary: v(CSS_VAR.shell.sidebarPrimary),
	sidebarHeaderBg: v(CSS_VAR.shell.sidebarHeaderBg),
	sidebarNavActiveBg: v(CSS_VAR.shell.sidebarNavActiveBg),
	sidebarForeground: v(CSS_VAR.shell.sidebarForeground),
	sidebarBorder: v(CSS_VAR.shell.sidebarBorder),
	sidebarNavHoverBg: v(CSS_VAR.shell.sidebarNavHoverBg),
	headerBg: v(CSS_VAR.shell.headerBg),
	headerFg: v(CSS_VAR.shell.headerFg),
	headerIcon: v(CSS_VAR.shell.headerIcon),
	headerBorder: v(CSS_VAR.shell.headerBorder),
	actionEdit: v(CSS_VAR.action.edit),
	actionEditSurface: v(CSS_VAR.action.editSurface),
} as const;
